import request from '../../utils/request';
import { API_ADMIN } from '../../utils/urls';

//菜小秘大前端
export function sendPhone(params) {
  return request({ url: 'channelRegister/add', params, baseURL: API_ADMIN, headers: 'json' });
}
